import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type CancelLetterRequestMutationVariables = Types.Exact<{
  letterRequestId: Types.Scalars['Int']
}>

export type CancelLetterRequestMutation = {
  __typename?: 'Mutation'
  cancelLetterRequest: { __typename?: 'LetterRequest'; id: number }
}

export const CancelLetterRequestDocument = gql`
  mutation CancelLetterRequest($letterRequestId: Int!) {
    cancelLetterRequest(letterRequestId: $letterRequestId) {
      id
    }
  }
`
export type CancelLetterRequestMutationFn = ApolloReactCommon.MutationFunction<
  CancelLetterRequestMutation,
  CancelLetterRequestMutationVariables
>
export function useCancelLetterRequestMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CancelLetterRequestMutation,
    CancelLetterRequestMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CancelLetterRequestMutation,
    CancelLetterRequestMutationVariables
  >(CancelLetterRequestDocument, options)
}
export type CancelLetterRequestMutationHookResult = ReturnType<
  typeof useCancelLetterRequestMutation
>
export type CancelLetterRequestMutationResult =
  ApolloReactCommon.MutationResult<CancelLetterRequestMutation>
export type CancelLetterRequestMutationOptions = ApolloReactCommon.BaseMutationOptions<
  CancelLetterRequestMutation,
  CancelLetterRequestMutationVariables
>
